exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".head-img[data-v-407eb503]{width:90%;margin:0 auto;display:block}.van-cell[data-v-407eb503]:not(:last-child):after{border:none}.van-cell[data-v-407eb503]{width:90%;margin:0 auto}[data-v-407eb503] .van-dialog__header{padding-left:10px;padding-right:10px}", ""]);

// exports
